import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { locale as italian } from "../../../../i18n/it";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CitiesService } from "../../../../auth/service/cities.service";
import * as moment from "moment";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { RoleService } from "../../../../auth/service/role.service";
import { CoreConfigService } from "@core/services/config.service";
import { ContractService } from "../../../../auth/service/contract.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import worldNationalities from "../../../../auth/models/nationality";
import { JobSiteService } from "../../../../auth/service/job-sites.service";
import { environment } from "../../../../../environments/environment";
import { ManageEmployeeContractService } from "app/auth/service/manage-employee-contract.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import EuropeanNationality from "../../../../auth/models/european-nationality";
import nationsWithCodes from "app/auth/models/nations-with-codes";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-user-form-edit",
  templateUrl: "./user-form-edit.component.html",
  styleUrls: ["./user-form-edit.component.scss"],
})
export class UserFormEditComponent implements OnInit {
  public formGroup: FormGroup;
  public pwdFormGroup: FormGroup;
  public addressResidence_FormGroup: FormGroup;
  public addressShipping_FormGroup: FormGroup;
  public active_table: string = "masterdata";
  public contentHeader: IContentHeader;
  public currentUser: any;
  public avatarImage: any;
  public today_date: string;
  public min_birthdate: string;
  public available_socials: Array<string> = [];
  public hr_list: any = [];
  public nationalities_list: Array<string> = worldNationalities;
  public europeanNationalities: Array<string> = EuropeanNationality;
  public me: ICurrentUser;
  public is_my_profile: boolean;
  public document_id_types: Array<object> = [];
  public file_resignation: any;
  public file_document_id: any;
  public file_fiscal_code: any;
  public file_residence_permit: any;
  public file_contract: any;
  public email_domain: string;
  public insert_valid_since: boolean = false;
  public valid_since: any;
  public initialContract: any = null;
  public afuConfig: any;
  public is_resigned: boolean = false;
  public fileNameFiscalCode: string = null;
  public fileNameResignation: string = null;
  public fileNameDocumentId: string = null;
  public fileNamePermit: string = null;
  public type_nationality: any = null;
  public currentNote: any;
  public oldPasswordType: boolean;
  public newPasswordType: boolean;
  public confirmPasswordType: boolean;
  public previousShippingAddress: any = {};
  public nationsWithCodes: { name: string; code: string }[] = nationsWithCodes;
  public isCopingResidence: boolean = false;
  constructor(
    public _citiesService: CitiesService,
    public _contractService: ContractService,
    public _userService: UserService,
    public _utilService: UtilsService,
    public _roleService: RoleService,
    public _userFigureService: UserFigureService,
    private _formBuilder: FormBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreConfigService: CoreConfigService,
    public _authenticationService: AuthenticationService,
    public _jobSiteService: JobSiteService,
    public _manageContract: ManageEmployeeContractService,
    private activated_route: ActivatedRoute,
    public _modalService: NgbModal,
    private _router: Router,
  ) {
    this.today_date = moment().format("YYYY-MM-DD");
    this.min_birthdate = moment().subtract(18, "year").format("YYYY-MM-DD");

    this.me = this._authenticationService.getCurrentUser();
    this._utilService.disableAutoHideLoading();

    this.activated_route.paramMap.subscribe(async (params: ParamMap) => {
      const userIdentifier: any = params.get("user_identifier");

      this.is_my_profile = this.me.hash === userIdentifier;
      if (!this._authenticationService.hasCapability("edit_other_user") && !this.is_my_profile) {
        this._utilService.hideLoading();
        await this._router.navigateByUrl("/dashboard/user/list/employee");
        return false;
      }
      if (userIdentifier) {
        await this.loadUserData(userIdentifier);
      }
    });

    this.activated_route.queryParams.subscribe((params) => {
      if (params.section) {
        this.active_table = params.section;
      }
      if (params.attachments) {
        this.active_table = "contract";
      }
    });

    this._coreConfigService.config.subscribe((params: any) => {
      this.available_socials = params.custom.user_available_socials;
      this.document_id_types = params.custom.document_id_types;
      this.email_domain = params.custom.email_domain;
    });

    this.formGroup = this._formBuilder.group({
      firstname: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      lastname: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      sex: new FormControl(""),
      site: new FormControl(""),
      birthday: new FormControl(""),
      addresses: new FormControl({}),
      figure: new FormControl("", !this.is_my_profile ? [Validators.required] : null),
      send_welcome_email: new FormControl(""),
      department: new FormControl(""),
      birth_place: new FormControl(""),
      private_phone: new FormControl("", [Validators.required, Validators.maxLength(15), Validators.minLength(9)]),
      set_public_phone: new FormControl(""),
      email: new FormControl("", [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      private_email: new FormControl("", [Validators.required, Validators.email]),
      set_public_email: new FormControl(""),
      fiscal_code: new FormControl("", [Validators.required, Validators.maxLength(16), Validators.minLength(16)]),
      nationality: new FormControl("", this.is_my_profile ? [Validators.required] : null),
      IBAN: new FormControl("", [Validators.maxLength(34), Validators.minLength(15)]),
      badge_number: new FormControl(null, [Validators.maxLength(10), Validators.minLength(1)]),
      tfr_amount: new FormControl(0),
      vat_number: new FormControl(""),
      civil_status: new FormControl(""),
      has_child: new FormControl(0, [Validators.min(0), Validators.max(1)]),
      residual_holidays: new FormControl(0),
      residual_permissions: new FormControl(0),
      child_number: new FormControl(0, [Validators.min(0)]),
      need_assets: new FormControl(0),
      send_onboarding: new FormControl(0),
      has_welcomebox: new FormControl(0),
      working_city: new FormControl(""),
      role: new FormControl("", !this.is_my_profile ? [Validators.required] : null),
      note: new FormControl(""),
      reference_hr: new FormControl(""),
      emergency_contact_firstname: new FormControl(""),
      emergency_contact_lastname: new FormControl(""),
      emergency_contact_phone: new FormControl("", [Validators.maxLength(16)]),
      socials: new FormControl({}),
      document_type: new FormControl("", this.is_my_profile ? [Validators.required] : null),
      document_number: new FormControl("", this.is_my_profile ? [Validators.required] : null),
      document_valid_until: new FormControl("", this.is_my_profile ? [Validators.required] : null),
      document_front_url: new FormControl(""),
      document_back_url: new FormControl(""),
      document_residence_permit_number: new FormControl(""),
      document_residence_permit_valid_until: new FormControl(""),
    });

    this.pwdFormGroup = this._formBuilder.group({
      current_password: new FormControl(""),
      new_password: new FormControl("", [Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})")]),
      confirm_password: new FormControl(""),
    });

    this.addressResidence_FormGroup = this._formBuilder.group({
      street: new FormControl("", [Validators.required, Validators.minLength(1)]),
      zipcode: new FormControl("", [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern("[0-9]+")]),
      city: new FormControl(null, [Validators.required, Validators.min(1)]),
      province: new FormControl(null, [Validators.required, Validators.min(1)]),
      external: new FormControl(false),
      country: new FormControl(null),
    });

    this.addressShipping_FormGroup = this._formBuilder.group({
      distance_from_us: !this.is_my_profile ? new FormControl(0, [Validators.required, Validators.min(0), Validators.max(2000)]) : new FormControl(0),
      street: !this.is_my_profile ? new FormControl("") : new FormControl("", [Validators.required, Validators.minLength(1)]),
      zipcode: !this.is_my_profile ? new FormControl("") : new FormControl("", [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern("[0-9]+")]),
      city: !this.is_my_profile ? new FormControl("") : new FormControl(null, [Validators.required, Validators.min(1)]),
      province: !this.is_my_profile ? new FormControl("") : new FormControl(null, [Validators.required, Validators.min(1)]),
      external: new FormControl(false),
      country: new FormControl(null),
    });
  }

  async ngOnInit() {
    await this._contractService.getLevels();

    this.hr_list = await this._userService.getList("employee", "Recruiter").then((list: any) =>
      list.map((item: any) => {
        return { hash: item.hash, name: `${item.firstname} ${item.lastname}` };
      }),
    );
  }

  ngOnDestroy() {
    this._manageContract.resetData();
  }

  transformRal(value: any) {
    const splittedValue: any = value.split("");

    if (value.includes(",") && splittedValue[splittedValue.length - 3] === "," && value.includes(".") && splittedValue[2] === ".") {
      value = this._utilService.removeDotsFromNumber(value);
    } else {
      // se include il punto e il punto è usato a index 2 - rimuovo quel punto
      if (value.includes(".") && splittedValue[2] === ".") {
        value = value.split("");
        delete value[2];
        value = value.join("");
      }
      // se include la virgola e la virgola è alla index 2 - rimuovo quella virgola
      if (value.includes(",") && splittedValue[2] === ",") {
        value = value.split("");
        delete value[2];
        value = value.join("");
      }
      // se include la virgola ed è il separatore dei decimali
      if (value.includes(",") && splittedValue[splittedValue.length - 3] === ",") {
        value = value.split("");
        value[-2] = ".";
        value = value.join("");
      }
    }

    value = Number(value);

    this._manageContract.changeSalaryGrossYearly(value);
  }

  async loadUserData(identifier: any) {
    this.currentUser = await this._userService.get(identifier).catch(async () => {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "NOT_FOUND_USER" });
      await this._router.navigateByUrl("/dashboard/user/list/employee");
      return false;
    });

    if (!this.currentUser) {
      this._utilService.hideLoading();
      await this._router.navigateByUrl("/dashboard/user/list/employee");
      return false;
    } else {
      //Controllo per i collaboratori se l'utente è un collaboratore non potrà accedere a questa pagina
      if (this._utilService.isACollaborator(this.currentUser)) {
        this._utilService.hideLoading();
        await this._router.navigateByUrl("/dashboard/main");
        return false;
      }
      if (this.currentUser.contract && Object.keys(this.currentUser.contract).length > 0) {
        if (this.currentUser.contract.contract_attachments && this.currentUser.contract.contract_attachments.length > 0) {
          this.currentUser.contract.contract_attachments.map((attachments) => {
            attachments.file_name = attachments.url.split("/")[2].replace(".pdf", "");
          });
        }

        if (this.currentUser.contract.resignation_url && this.currentUser.contract.resignation_url.length > 0) {
          if (!this.currentUser.contract.contract_attachments) {
            this.currentUser.contract.contract_attachments = [];
          }
          this.currentUser.contract.contract_attachments.push({
            url: this.currentUser.contract.resignation_url,
            file_name: "Comunicazione INPS dimissioni",
          });
        }

        this.is_resigned = this.currentUser.contract.closed_at !== null && this.currentUser.contract.resignation_url !== null;
      }

      this.afuConfig = {
        multiple: true,
        formatsAllowed: ".pdf",
        maxSize: 2,
        uploadAPI: {
          url: environment.API_BASEURL + "/user/" + this.currentUser.hash,
          method: "PUT",
        },
        replaceTexts: {
          afterUploadMsg_success: await this._utilService.translate("SUCCESS_UPLOAD_FILES"),
          afterUploadMsg_error: await this._utilService.translate("ERROR_UPLOAD_FILES"),
          sizeLimit: await this._utilService.translate("FILE_SIZE_LIMIT"),
        },
      };
      if (this.currentUser.socials) {
        const objectSocials: any = {};
        this.currentUser.socials.map((social: any) => (objectSocials[social.name] = social.url));
        this.currentUser.socials = objectSocials;
      }

      if (this.currentUser.addresses?.residenza) {
        this.addressResidence_FormGroup.patchValue({
          street: this.currentUser.addresses.residenza.street ? this.currentUser.addresses.residenza.street : "",
          zipcode: this.currentUser.addresses.residenza.zipcode ? this.currentUser.addresses.residenza.zipcode : "",
          city: this.currentUser.addresses.residenza.city_id ? this.currentUser.addresses.residenza.city_id : 0,
          province: this.currentUser.addresses.residenza.province_id ? this.currentUser.addresses.residenza.province_id : 0,
          country: this.currentUser.addresses.residenza.country ? this.currentUser.addresses.residenza.country : null,
          external: this.currentUser.addresses.residenza.country ? true : false,
        });
      }
      if (this.currentUser.contract && Object.keys(this.currentUser.contract).length > 0) {
        this.initialContract = this.currentUser.contract;
      }
      if (this.currentUser.addresses?.spedizione) {
        this.addressShipping_FormGroup.patchValue({
          street: this.currentUser.addresses.spedizione.street ? this.currentUser.addresses.spedizione.street : "",
          zipcode: this.currentUser.addresses.spedizione.zipcode ? this.currentUser.addresses.spedizione.zipcode : "",
          city: this.currentUser.addresses.spedizione.city ? this.currentUser.addresses.spedizione.city_id : 0,
          province: this.currentUser.addresses.spedizione.province ? this.currentUser.addresses.spedizione.province_id : 0,
          distance_from_us: this.currentUser.addresses.spedizione.distance_from_us ? this.currentUser.addresses.spedizione.distance_from_us : 0,
          country: this.currentUser.addresses.spedizione.country ? this.currentUser.addresses.spedizione.country : null,
          external: this.currentUser.addresses.spedizione.country ? true : false,
        });
        //Nel caso spedizione sia valorizzato lo salvo in previousShippingAddress
        if (!!this.currentUser.addresses.spedizione.street && !!this.currentUser.addresses.spedizione.zipcode && !!this.currentUser.addresses.spedizione.city && !!this.currentUser.addresses.spedizione.province) {
          this.previousShippingAddress = this.currentUser.addresses.spedizione;
        }
        if (!!this.currentUser.addresses.spedizione.street && !!this.currentUser.addresses.spedizione.country) {
          this.previousShippingAddress = this.currentUser.addresses.spedizione;
        }
      }

      //Controllo se ci sia una sede estera e nel caso aggiusto i validatori
      if (this.addressResidence_FormGroup.value.external) {
        this.manageExternalSiteResidence();
      }
      if (this.addressShipping_FormGroup.value.external) {
        this.manageExternalSiteLiving();
      }

      this.formGroup.patchValue({
        firstname: this.currentUser.firstname,
        lastname: this.currentUser.lastname,
        sex: this.currentUser.sex,
        site: this.currentUser.site_id,
        birthday: moment(this.currentUser.birthday).format("YYYY-MM-DD"),
        addresses: this.currentUser.addresses,
        figure: this.currentUser.figure_id,
        department: this.currentUser.department_id,
        birth_place: this.currentUser.birth_place_id,
        private_phone: this.currentUser.private_phone,
        email: this.currentUser.email,
        private_email: this.currentUser.private_email,
        set_public_email: !!this.currentUser.public_email,
        set_public_phone: !!this.currentUser.public_phone,
        fiscal_code: this.currentUser.fiscal_code,
        nationality: this.currentUser.nationality,
        IBAN: this.currentUser.IBAN,
        badge_number: this.currentUser.badge_number,
        tfr_amount: this._utilService.addDotsToNumber(this.currentUser.tfr_amount || 0),
        vat_number: this.currentUser.vat_number,
        civil_status: this.currentUser.civil_status,
        has_child: this.currentUser.has_child,
        residual_holidays: this.currentUser.residual_holidays,
        residual_permissions: this.currentUser.residual_permissions,
        child_number: this.currentUser.child_number,
        need_assets: this.currentUser.need_assets,
        send_onboarding: this.currentUser.send_onboarding,
        has_welcomebox: this.currentUser.has_welcomebox,
        working_city: this.currentUser.working_city_id,
        role: this.currentUser.role_id,
        reference_hr: this.currentUser.hr_hash,
        emergency_contact_firstname: this.currentUser.emergency_contact_firstname,
        emergency_contact_lastname: this.currentUser.emergency_contact_lastname,
        emergency_contact_phone: this.currentUser.emergency_contact_phone,
        socials: this.currentUser.socials || {},
      });

      if (this.currentUser.document_id) {
        this.formGroup.patchValue({
          document_type: this.currentUser.document_id.type,
          document_number: this.currentUser.document_id.number,
          document_valid_until: this.currentUser.document_id.valid_until,
          document_residence_permit_number: this.currentUser.document_id.residence_permit_number,
          document_residence_permit_valid_until: this.currentUser.document_id.residence_permit_valid_until,
        });
      }
      if (this.currentUser && this.currentUser.nationality && this.currentUser.nationality.length > 0 && this.currentUser.nationality === "Italiana") {
        this.type_nationality = "Italiana";
      } else if (this.currentUser && this.currentUser.nationality && this.currentUser.nationality.length > 0 && this.europeanNationalities.includes(this.currentUser.nationality)) {
        this.type_nationality = "UE";
      } else if (
        this.currentUser &&
        this.currentUser.nationality &&
        this.currentUser.nationality.length > 0 &&
        this.currentUser.nationality !== "Italiana" &&
        !this.europeanNationalities.includes(this.currentUser.nationality)
      ) {
        this.type_nationality = "Extra Ue";
      }

      const headerBreadcrumbs: any = [
        {
          name: "Home",
          isLink: true,
          link: "/",
        },
      ];

      if (!this.is_my_profile) {
        headerBreadcrumbs.push({
          name: italian.data.TITLES.USERS_TYPES.employee,
          isLink: true,
          link: `/dashboard/user/list/${this.currentUser.type_code}`,
        });
        headerBreadcrumbs.push({
          name: this.currentUser.firstname + " " + this.currentUser.lastname,
          isLink: true,
          link: `/dashboard/user/profile/${this.currentUser.hash}`,
        });
      } else {
        headerBreadcrumbs.push({
          name: italian.data.TITLES.PROFILE,
          isLink: true,
          link: `/dashboard/user/profile/${this.currentUser.hash}`,
        });
      }

      headerBreadcrumbs.push({
        name: italian.data.EDIT,
        isLink: false,
      });

      this.contentHeader = {
        headerTitle: italian.data.TITLES.EDIT_PROFILE,
        actionButton: false,
        breadcrumb: {
          type: "",
          links: headerBreadcrumbs,
        },
      };

      this.avatarImage = this.currentUser.avatar;

      this._changeDetectorRef.detectChanges();
    }

    this.currentNote = this.formGroup.value.note;
    this._utilService.hideLoading();
  }

  hasCapability(name: string) {
    return this._authenticationService.hasCapability(name);
  }

  handlerChangeOfficeEmail(event) {
    const value: string = event.target.value.toLowerCase();
    if (!value.includes(this.email_domain) && !value.includes("@")) {
      this.formGroup.patchValue({ email: value + this.email_domain });
    }
  }

  handlerChangeChild() {
    const childNumber: number = Number(this.formGroup.get("child_number").value);
    this.formGroup.patchValue({ has_child: childNumber > 0 ? 1 : 0 });
  }

  fieldHasErrors(field_name: string): boolean {
    return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
  }

  async copyResidence() {
    //Resetto i valori
    this.addressShipping_FormGroup.patchValue({
      street: null,
      zipcode: null,
      city: null,
      province: null,
      country: null,
    });

    this.addressShipping_FormGroup.patchValue({
      street: this.addressResidence_FormGroup.value.street,
      zipcode: this.addressResidence_FormGroup.value.zipcode,
      city: this.addressResidence_FormGroup.value.city,
      province: this.addressResidence_FormGroup.value.province,
      country: this.addressResidence_FormGroup.value.country,
      external: this.addressResidence_FormGroup.value.external,
    });

    this.manageExternalSiteLiving();
  }

  handlerChangeSocial(social: string, target: any) {
    let currentSocials: any = this.formGroup.get("socials").value;
    if (!currentSocials || Object.keys(currentSocials).length < 1) {
      currentSocials = {};
    }

    document.querySelector(`#social-link-${social}-container`).classList.remove("is-invalid");
    document.querySelector(`#social-link-${social}`).classList.remove("is-invalid");

    try {
      const value: any = new URL(String(target.value).trim());
      currentSocials[social] = value.href;
      this.formGroup.patchValue({ socials: currentSocials });
    } catch (e: any) {
      document.querySelector(`#social-link-${social}-container`).classList.add("is-invalid");
      document.querySelector(`#social-link-${social}`).classList.add("is-invalid");
    }
  }

  formatTfrAmount() {
    if (!!this.formGroup.value.tfr_amount) {
      this.formGroup.patchValue({
        tfr_amount: this._utilService.addDotsToNumber(this.formGroup.value.tfr_amount),
      });
    } else {
      this.formGroup.patchValue({
        tfr_amount: null,
      });
    }
  }

  handlerChangeFileInput(event: any, what: string) {
    what === "fiscal-code" ? (this.fileNameFiscalCode = event.target.files[0].name) : null;
    what === "residence-permit" ? (this.fileNamePermit = event.target.files[0].name) : null;
    what === "document-id" ? (this.fileNameDocumentId = event.target.files[0].name) : null;
    this._utilService.convertFileToBase64(event, (e: any) => {
      const r = e.target.result;
      switch (what) {
        case "document-id":
          this.file_document_id = r;
          break;
        case "fiscal-code":
          this.file_fiscal_code = r;
          break;
        case "resignation":
          this.file_resignation = r;
          break;
        case "avatar":
          this.avatarImage = r;
          break;
        case "residence-permit":
          this.file_residence_permit = r;
          break;
        case "contract-file":
          this.file_contract = r;
          break;
      }
    });
  }

  setAutoProvince(address_label: string = "Residence") {
    const cityValue: number = this[`address${address_label}_FormGroup`].get("city").value;
    if (cityValue > 0) {
      const cityObj: any = this._citiesService.list.find((city: any) => city.id === cityValue);
      const province = this._citiesService.list.find((city: any) => city.initials === cityObj.initials && city.is_main === 1);
      this[`address${address_label}_FormGroup`].patchValue({ province: province.id });
    }
  }

  isDisabledSave() {
    let disableSave: boolean = true;
    if (!this.avatarImage && !this._authenticationService.hasCapability("edit_other_user") && !this.is_my_profile) return true;
    if (!this.avatarImage && this.is_my_profile) return true;

    if (!this.is_my_profile) {
      //Si può inviare spedizioni vuoto ma se si prova a inserire un solo campo il bottone si disabilita
      if (
        !this.addressShipping_FormGroup.value.external &&
        !this.addressShipping_FormGroup.value.street &&
        !this.addressShipping_FormGroup.value.zipcode &&
        !this.addressShipping_FormGroup.value.city &&
        !this.addressShipping_FormGroup.value.province
      ) {
        return false;
      }

      if (
        !this.addressShipping_FormGroup.value.external &&
        (!this.addressShipping_FormGroup.value.street || !this.addressShipping_FormGroup.value.zipcode || !this.addressShipping_FormGroup.value.city || !this.addressShipping_FormGroup.value.province)
      ) {
        return true;
      }

      if ((!this.addressShipping_FormGroup.value.street || !this.addressShipping_FormGroup.value.country) && this.addressShipping_FormGroup.value.external) {
        return true;
      }
    }

    const formsKeys: Array<string> = ["formGroup", "pwdFormGroup", "addressResidence_FormGroup", "addressShipping_FormGroup"];
    formsKeys.map((group_name: string) => {
      Object.keys(this[group_name].controls).map((field: string) => {
        if (this[group_name].controls[field].invalid && disableSave) {
          disableSave = false;
        }
      });
    });

    if (!disableSave) {
      return (disableSave = true);
    }
    if (!this.is_my_profile) {
      if (this.initialContract) {
        //Controllo che l'utente abbia un contratto precedente se ce controlliamo valid_since
        if (this.insert_valid_since && !this.valid_since) {
          return true;
        }
      }
    }

    return false;
  }

  async save() {
    //Controllo alert campi mancanti
    let keyToShowError: any = [];
    Object.keys(this.formGroup.controls).map((key) => {
      if (this.formGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    Object.keys(this.addressResidence_FormGroup.controls).map((key) => {
      if (this.addressResidence_FormGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    Object.keys(this.addressShipping_FormGroup.controls).map((key) => {
      if (this.addressShipping_FormGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });

    if (this.formGroup.invalid || this.addressResidence_FormGroup.invalid || this.addressShipping_FormGroup.invalid) {
      let textMessage = await this._utilService.translate("SOME_DATA_ARE_NOT_VALID");
      keyToShowError = await Promise.all(
        keyToShowError.map(async (key) => {
          key = await this._utilService.translate(key.toUpperCase());
          return key.toLowerCase();
        }),
      );
      keyToShowError.map((item: any, index: number = 0) => {
        index + 1 < keyToShowError.length ? (textMessage += item += ", ") : (textMessage += item += ".");
      });
      //id document
      if (!this.is_my_profile) {
        if (this.formGroup.controls.fiscal_code.status === "INVALID") {
          this.active_table = "id_document";
        }
      } else {
        if (
          !this.type_nationality ||
          this.formGroup.controls.fiscal_code.status === "INVALID" ||
          this.formGroup.controls.document_type.status === "INVALID" ||
          this.formGroup.controls.nationality.status === "INVALID" ||
          this.formGroup.controls.document_number.status === "INVALID" ||
          this.formGroup.controls.document_valid_until.status === "INVALID" ||
          this.formGroup.controls.document_residence_permit_number.status === "INVALID" ||
          this.formGroup.controls.document_residence_permit_valid_until.status === "INVALID"
        ) {
          this.active_table = "id_document";
        }
      }
      // addresses
      if (this.addressResidence_FormGroup.invalid || this.addressShipping_FormGroup.invalid) {
        this.active_table = "addresses";
      }
      //informations
      if (
        this.formGroup.controls.figure.status === "INVALID" ||
        this.formGroup.controls.private_email.status === "INVALID" ||
        this.formGroup.controls.private_phone.status === "INVALID" ||
        this.formGroup.controls.role.status === "INVALID"
      ) {
        this.active_table = "informations";
      }
      //masterData
      if (this.formGroup.controls.firstname.status === "INVALID" || this.formGroup.controls.lastname.status === "INVALID") {
        this.active_table = "masterdata";
      }
      return this._utilService.showSWALEmptyField({ text: textMessage });
    }
    //Controllo dimissioni data conclusione obbligatoria
    if (!this.is_my_profile) {
      if ((this.fileNameResignation || this._manageContract.data.closed_reason) && !this._manageContract.data.closed_at) {
        await this._utilService.showSWALError({ text: "INSERT_CLOSED_AT_RESIGNATION" });
        return false;
      }
    }

    //Fine controllo alert campi mancanti
    let data: any = this.formGroup.value;
    data.birthday = this.formGroup.controls.birthday.touched && data.birthday.length > 0 ? data.birthday : null;

    if (!this.is_my_profile) {
      data.send_onboarding = data.send_onboarding ? 1 : 0;
    }
    if (data.socials) {
      data.socials = typeof data.socials === "string" ? data.socials : JSON.stringify(data.socials);
    } else {
      data.socials = "{}";
    }
    //Settiamo i campi public email e public phone se toggle spuntato
    if (data.private_phone && data.private_phone.length > 0) {
      data.private_phone = data.private_phone.replace(/ /g, ""); //Rimozione spazi
    }
    if (data.emergency_contact_phone && data.emergency_contact_phone.length > 0) {
      data.emergency_contact_phone = data.emergency_contact_phone.replace(/ /g, ""); //Rimozione spazi
    }

    data.public_email = this.formGroup.value.set_public_email === true ? data.private_email : "";
    data.public_phone = this.formGroup.value.set_public_phone === true ? data.private_phone : "";
    delete data.set_public_email;
    delete data.set_public_phone;

    Object.keys(data).map((key_name: string) => {
      if (key_name === "socials") {
        return true;
      }

      if (data[key_name] === undefined || data[key_name] === null || data[key_name] === this.currentUser[key_name]) {
        delete data[key_name];
      }

      if ((key_name === "contract_end_date" || key_name === "contract_start_date") && data[key_name] === "") {
        delete data[key_name];
      }

      if (data[key_name] && data[key_name].length < 1) {
        data[key_name] = null;
      }
    });

    data.type = this.currentUser?.type_code;

    if (this.avatarImage && this.avatarImage !== this.currentUser.avatar) {
      await this._userService.uploadAvatar(this.currentUser.hash, this.avatarImage).catch(() => this._utilService.showSWALError({ text: "AVATAR_UPLOAD_ERROR" }));
    }

    const userMinioDir: string = `users/${this.currentUser.hash}/`;

    if ((this.file_document_id && (data.document_type || this.currentUser.document_id.type)) || this.file_fiscal_code) {
      const baseDocumentFileName: string = `${userMinioDir}documento-didentita/`;

      if (this.file_document_id) {
        const fileDocumentIdExt: string = this.file_document_id.split(";base64,")[0].split("/")[1];
        await this._utilService
          .upload_media("documents", baseDocumentFileName + (data.document_type || this.currentUser.document_id.type) + "." + fileDocumentIdExt, this.file_document_id)
          .then((response: any) => {
            data.document_url = baseDocumentFileName + response.url.split("/").pop();
          })
          .catch(() => this._utilService.showSWALError({ text: "ID_DOCUMENT_UPLOAD_ERROR" }));
      }

      if (this.file_fiscal_code) {
        const fileDocumentIdExt: string = this.file_fiscal_code.split(";base64,")[0].split("/")[1];
        await this._utilService
          .upload_media("documents", baseDocumentFileName + "fiscal-code." + fileDocumentIdExt, this.file_fiscal_code)
          .then((response: any) => {
            data.fiscalcode_url = baseDocumentFileName + response.url.split("/").pop();
          })
          .catch(() => this._utilService.showSWALError({ text: "FISCAL_CODE_UPLOAD_ERROR" }));
      }
    }

    if (this.file_residence_permit) {
      const fileExt: string = this.file_residence_permit.split(";base64,")[0].split("/")[1];
      await this._utilService
        .upload_media("documents", `${userMinioDir}permesso-di-soggiorno/file.${fileExt}`, this.file_residence_permit)
        .then((response: any) => {
          data.residence_permit_url = `${userMinioDir}permesso-di-soggiorno/` + response.url.split("/").pop();
        })
        .catch(() => this._utilService.showSWALError({ text: "RESIDENCE_PERMIT_UPLOAD_ERROR" }));
    }

    data.addresses = {};

    if (this.addressResidence_FormGroup.valid) {
      if (JSON.stringify(this.addressResidence_FormGroup.value) !== (this.currentUser.addresses.residenza || {})) {
        data.addresses.residenza = {
          city: this.addressResidence_FormGroup.value.city,
          country: this.addressResidence_FormGroup.value.country,
          province: this.addressResidence_FormGroup.value.province,
          street: this.addressResidence_FormGroup.value.street,
          zipcode: this.addressResidence_FormGroup.value.zipcode,
        };
      }
    } else {
      const residenceAddress: any = this.addressResidence_FormGroup.value;
      if (residenceAddress.street.length > 0 || residenceAddress.zipcode.length > 0 || residenceAddress.city > 0 || residenceAddress.province > 0) {
        await this._utilService.showSWALError({ text: "RESIDENCE_ADDRESS_NOT_COMPLETE" });
      }
    }

    if (this.addressShipping_FormGroup.valid) {
      if (JSON.stringify(this.addressShipping_FormGroup.value) !== JSON.stringify(this.currentUser.addresses.spedizione || {})) {
        data.addresses.spedizione = {
          city: this.addressShipping_FormGroup.value.city,
          country: this.addressShipping_FormGroup.value.country,
          province: this.addressShipping_FormGroup.value.province,
          street: this.addressShipping_FormGroup.value.street,
          zipcode: this.addressShipping_FormGroup.value.zipcode,
        };
      }
    } else {
      const shippingAddress: any = this.addressShipping_FormGroup.value;
      if (shippingAddress.street.length > 0 || shippingAddress.zipcode.length > 0 || shippingAddress.city > 0 || shippingAddress.province > 0) {
        await this._utilService.showSWALError({ text: "SHIPPING_ADDRESS_NOT_COMPLETE" });
      }
    }

    if (Object.keys(data.addresses).length < 1) {
      delete data.addresses;
    }

    if (Object.keys(data).length < 1) {
      return this._utilService.showSWALError({ text: "NOTHING_TO_UPDATE" });
    }

    if (data.start_date > data.end_date) {
      await this._utilService.showSWALError({ text: "ERROR_DATE_INSERT" });
      return false;
    }
    // if (data.end_date <= moment(data.start_date).add(data.trial, "days").format("YYYY-MM-DD")) {
    //   await this._utilService.showSWALError({ text: "CONTROL_CONTRACT_DATE" });
    //   return false;
    // }
    this._utilService.showLoading();
    return this._userService
      .update(this.currentUser.hash, data)
      .then(async () => {
        this._utilService.hideLoading();
        if (this.file_contract) {
          const contractFileName: any = `users/${this.currentUser.hash}/Contratto-${this.currentUser.contract.contract_name}-${moment().valueOf()}.pdf`;

          const uploadContract: any = await this._utilService.upload_media("documents", contractFileName, this.file_contract);
          if (!uploadContract) {
            await this._utilService.showSWALError({ text: "ERROR_UPLOAD_CONTRACT" });
            return false;
          }

          await this._userService.update(this.currentUser.hash, { contract_url: contractFileName }).then(async () => {
            this.currentUser.contract_url = contractFileName;
          });
        }
        if (this.currentUser.hash === this.me.hash) {
          //Se tutti i valori di spedizione sono valorizzati
          if (data.addresses.spedizione && !!data.addresses.spedizione.city && !!data.addresses.spedizione.province && !!data.addresses.spedizione.street && !!data.addresses.spedizione.zipcode) {
            //Controllo per capire se sono stati cambiati nel caso siano cambiati aggiorniamo la distanza
            if (
              data.addresses.spedizione &&
              (data.addresses.spedizione.street !== this.previousShippingAddress.street ||
                data.addresses.spedizione.city !== this.previousShippingAddress.city_id ||
                data.addresses.spedizione.province !== this.previousShippingAddress.province_id ||
                data.addresses.spedizione.zipcode !== this.previousShippingAddress.zipcode)
            ) {
              await this._userService.calculateDistanceForEmployeeToUs(this.currentUser.hash);
            }
          }
          await this._userService.getMe().then(async (response: any) => {
            let userLocalStorage = JSON.parse(localStorage.getItem("currentUser"));
            response.capabilities = userLocalStorage.capabilities;
            localStorage.setItem("currentUser", JSON.stringify(response));
            await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_USER" });
            window.location.href = "/dashboard/user/profile/" + this.currentUser.hash;
          });
        } else {
          if (data.addresses.spedizione && !!data.addresses.spedizione.street && !!data.addresses.spedizione.city && data.addresses.spedizione.distance_from_us < 3) {
            await this._userService
              .calculateDistanceForEmployeeToUs(this.currentUser.hash)
              .then(async () => {
                await this._utilService.showSWALSuccess({ text: "SUCCESS_CALCULATE_DISTANCE_EMPLOYEE" });
              })
              .catch(async () => {
                await this._utilService.showSWALError({ text: "ERROR_CALCULATE_DISTANCE_EMPLOYEE" });
              });
          } else {
            //Controllo se i dati di spedizioni siano cambiati, se si cambiamo il calcolo della distanza
            if (
              data.addresses.spedizione &&
              data.addresses.spedizione.street.length > 0 &&
              (data.addresses.spedizione.street !== this.previousShippingAddress.street ||
                data.addresses.spedizione.city !== this.previousShippingAddress.city_id ||
                data.addresses.spedizione.province !== this.previousShippingAddress.province_id ||
                (data.addresses.spedizione.zipcode !== this.previousShippingAddress.zipcode && this.previousShippingAddress.distance_from_us === data.addresses.spedizione.distance_from_us))
            ) {
              await this._userService
                .calculateDistanceForEmployeeToUs(this.currentUser.hash)
                .then(async () => {
                  await this._utilService.showSWALSuccess({ text: "SUCCESS_CALCULATE_DISTANCE_EMPLOYEE" });
                })
                .catch(async () => {
                  await this._utilService.showSWALError({ text: "ERROR_CALCULATE_DISTANCE_EMPLOYEE" });
                });
            }
          }
          await this.loadUserData(this.currentUser.hash).then(async () => {
            await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_USER" });
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPDATE_USER" });
      });
  }

  async restoreEmployee() {
    this._utilService.showLoading();
    const hash = this.currentUser.hash;
    return this._userService.restoreEmployee(hash)
      .then(async () => {
        await this.loadUserData(hash);
        this._utilService.hideLoading();
        this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_USER" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPDATE_USER" });
      });
  }

  removePwdErrors(error: string) {
    const errors: any = this.pwdFormGroup.errors || {};
    delete errors[error];
    this.pwdFormGroup.setErrors(errors);
  }

  async changePassword() {
    const data: any = this.pwdFormGroup.value;

    if (!this.is_my_profile && !this.currentUser.capabilities.includes("change_others_passwords")) {
      return this._utilService.showSWALError({ text: "UNAUTHORIZED" });
    }

    if (String(data.current_password).length < 1 && String(data.new_password).length < 1 && String(data.confirm_password).length < 1) {
      return this._utilService.showSWALError({ text: "NOTHING_TO_UPDATE" });
    }

    if (RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})").test(data.new_password)) {
      this.removePwdErrors("weakPassword");
    } else {
      this.pwdFormGroup.setErrors({ weakPassword: true });
      return false;
    }

    if (String(data.new_password).trim() !== String(data.confirm_password).trim()) {
      this.pwdFormGroup.setErrors({ notSamePwd: true });
      return false;
    } else {
      this.removePwdErrors("notSamePwd");
    }

    delete data.confirm_password;

    await this._userService
      .change_password(this.currentUser.hash, data)
      .then(() => {
        this.pwdFormGroup.reset();
        this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_USER_PASSWORD" });
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_UPDATE_USER_PASSWORD" }));
  }

  togglePasswordTextType(which: string) {
    if (which === "old") {
      this.oldPasswordType = !this.oldPasswordType;
    }
    if (which === "new") {
      this.newPasswordType = !this.newPasswordType;
    }
    if (which === "confirm") {
      this.confirmPasswordType = !this.confirmPasswordType;
    }
  }

  async viewDocument(url: string) {
    await this._utilService.getFile(url);
  }

  modalOpen(modalBasic, currentNote) {
    this.formGroup.patchValue({ note: "" });
    this._modalService.open(modalBasic, {
      size: "sm",
      centered: true,
    });
    this.currentNote = JSON.parse(JSON.stringify(currentNote));
  }

  async addNote() {
    let data = { note: null, hash: this.currentUser.hash };
    data.note = this.formGroup.value.note.trim();
    return this._userService
      .createNote(data)
      .then(async () => {
        await this._utilService.showLoading();
        await this.loadUserData(this.currentUser.hash);
        await this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_INSERT_NOTE" });
      })
      .catch(async () => {
        await this._utilService.showSWALError({ text: "ERROR_INSERT_NOTE" });
      });
  }

  async editNote() {
    let data = {
      note: this.currentNote.note.trim(),
    };
    let hash = this.currentUser.hash;
    let id = String(this.currentNote.id);
    return this._userService
      .updateNote(hash, id, data)
      .then(async () => {
        await this._utilService.showLoading();
        await this.loadUserData(this.currentUser.hash);
        await this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_NOTE" });
      })
      .catch(async () => {
        await this._utilService.showSWALError({ text: "SUCCESS_DELETE_NOTE" });
      });
  }

  async deleteNote(row: any) {
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_NOTE");
    deleteText += `${row.note}`;

    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        this._utilService.showLoading();
        return this._userService
          .deleteNote(this.currentUser.hash, String(row.id))
          .then(async () => {
            await this.loadUserData(this.currentUser.hash);
            await this._utilService.hideLoading();
            await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_NOTE" });
          })
          .catch(async () => {
            await this._utilService.hideLoading();
            await this._utilService.showSWALError({ text: "ERROR_DELETE_NOTE" });
          });
      } else if (result.isDismissed) {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }

  setCountry() {
    this.formGroup.get("document_residence_permit_number").clearValidators();
    this.formGroup.get("document_residence_permit_number").clearValidators();
    this.formGroup.patchValue({
      nationality: "",
    });
    if (this.type_nationality == "Italiana") {
      this.formGroup.patchValue({
        nationality: "Italiana",
      });
    }
    if (this.type_nationality === "Extra Ue" && this.is_my_profile) {
      this.formGroup.controls.document_residence_permit_number.setValidators([Validators.required]);
      this.formGroup.controls.document_residence_permit_valid_until.setValidators([Validators.required]);
    }
  }

  async checkEmptyFieldAlert() {
    let keyToShowError: any = [];
    Object.keys(this.formGroup.controls).map((key) => {
      if (this.formGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    Object.keys(this.addressResidence_FormGroup.controls).map((key) => {
      if (this.addressResidence_FormGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    Object.keys(this.addressShipping_FormGroup.controls).map((key) => {
      if (this.addressShipping_FormGroup.controls[key].status === "INVALID") {
        keyToShowError.push(key);
      }
    });
    let isShippingStaffInvalid: boolean = false;
    if (!this.is_my_profile) {
      //Indirizzo domicilio per lo staff è facoltativo ma controlliamo se almeno un campo è inserito tutti gli altri devono essere completi
      if (
        !this.addressShipping_FormGroup.value.external &&
        (!!this.addressShipping_FormGroup.value.street || !!this.addressShipping_FormGroup.value.city || !!this.addressShipping_FormGroup.value.zipcode || !!this.addressShipping_FormGroup.value.province)
      ) {
        if (!this.addressShipping_FormGroup.value.street || !this.addressShipping_FormGroup.value.city || !this.addressShipping_FormGroup.value.zipcode || !this.addressShipping_FormGroup.value.province) {
          keyToShowError.push(italian.data.SHIPPING_ADDRESS);
          isShippingStaffInvalid = true;
          this.active_table = "addresses";
        }
      }
      //Controllo nel caso di estero
      if (this.addressShipping_FormGroup.value.external && (!!this.addressShipping_FormGroup.value.street || !!this.addressShipping_FormGroup.value.country)) {
        if (!this.addressShipping_FormGroup.value.street || !this.addressShipping_FormGroup.value.country) {
          keyToShowError.push(italian.data.SHIPPING_ADDRESS);
          isShippingStaffInvalid = true;
          this.active_table = "addresses";
        }
      }
    }
    if (this.formGroup.invalid || this.addressResidence_FormGroup.invalid || this.addressShipping_FormGroup.invalid || isShippingStaffInvalid) {
      let textMessage = await this._utilService.translate("SOME_DATA_ARE_NOT_VALID");
      keyToShowError = await Promise.all(
        keyToShowError.map(async (key) => {
          key = await this._utilService.translate(key.toUpperCase());
          return key.toLowerCase();
        }),
      );
      keyToShowError.map((item, index: number = 0) => {
        index + 1 < keyToShowError.length ? (textMessage += item += ", ") : (textMessage += item += ".");
      });

      //id document
      if (!this.is_my_profile) {
        if (this.formGroup.controls.fiscal_code.status === "INVALID") {
          this.active_table = "id_document";
        }
      } else {
        if (
          !this.type_nationality ||
          this.formGroup.controls.fiscal_code.status === "INVALID" ||
          this.formGroup.controls.document_type.status === "INVALID" ||
          this.formGroup.controls.nationality.status === "INVALID" ||
          this.formGroup.controls.document_number.status === "INVALID" ||
          this.formGroup.controls.document_valid_until.status === "INVALID" ||
          this.formGroup.controls.document_residence_permit_number.status === "INVALID" ||
          this.formGroup.controls.document_residence_permit_valid_until.status === "INVALID"
        ) {
          this.active_table = "id_document";
        }
      }
      // addresses
      if (this.addressResidence_FormGroup.invalid || this.addressShipping_FormGroup.invalid) {
        this.active_table = "addresses";
      }
      //informations
      if (
        this.formGroup.controls.figure.status === "INVALID" ||
        this.formGroup.controls.private_email.status === "INVALID" ||
        this.formGroup.controls.private_phone.status === "INVALID" ||
        this.formGroup.controls.role.status === "INVALID"
      ) {
        this.active_table = "informations";
      }
      //masterData
      if (this.formGroup.controls.firstname.status === "INVALID" || this.formGroup.controls.lastname.status === "INVALID") {
        this.active_table = "masterdata";
      }
      return this._utilService.showSWALEmptyField({ text: textMessage });
    }
    //Fine Alert modifica profilo non personale
  }

  manageExternalSiteResidence() {
    this.isCopingResidence = false;
    if (this.addressResidence_FormGroup.value.external) {
      this.addressResidence_FormGroup.get("country").addValidators(Validators.required);
      this.addressResidence_FormGroup.get("city").clearValidators();
      this.addressResidence_FormGroup.get("zipcode").clearValidators();
      this.addressResidence_FormGroup.get("province").clearValidators();
      this.addressResidence_FormGroup.patchValue({
        province: null,
        city: null,
        zipcode: null,
      });
    } else {
      this.addressResidence_FormGroup.patchValue({
        country: null,
      });
      this.addressResidence_FormGroup.get("country").clearValidators();
      this.addressResidence_FormGroup.get("province").addValidators(Validators.required);
      this.addressResidence_FormGroup.get("city").addValidators(Validators.required);
      this.addressResidence_FormGroup.get("zipcode").addValidators(Validators.required);
      this.addressResidence_FormGroup.get("zipcode").addValidators(Validators.minLength(5));
      this.addressResidence_FormGroup.get("zipcode").addValidators(Validators.maxLength(5));
      this.addressResidence_FormGroup.get("zipcode").addValidators(Validators.pattern("[0-9]+"));
    }
    this.addressResidence_FormGroup.get("country").updateValueAndValidity();
    this.addressResidence_FormGroup.get("city").updateValueAndValidity();
    this.addressResidence_FormGroup.get("zipcode").updateValueAndValidity();
    this.addressResidence_FormGroup.get("province").updateValueAndValidity();
  }

  manageExternalSiteLiving() {
    this.isCopingResidence = false;
    if (this.addressShipping_FormGroup.value.external) {
      if (this.is_my_profile) {
        this.addressShipping_FormGroup.get("country").addValidators(Validators.required);
        this.addressShipping_FormGroup.get("city").clearValidators();
        this.addressShipping_FormGroup.get("zipcode").clearValidators();
        this.addressShipping_FormGroup.get("province").clearValidators();
      }
      this.addressShipping_FormGroup.patchValue({
        province: null,
        city: null,
        zipcode: null,
      });
    } else {
      this.addressShipping_FormGroup.patchValue({
        country: null,
      });
      if (this.is_my_profile) {
        this.addressShipping_FormGroup.get("country").clearValidators();
        this.addressShipping_FormGroup.get("province").addValidators(Validators.required);
        this.addressShipping_FormGroup.get("city").addValidators(Validators.required);
        this.addressShipping_FormGroup.get("zipcode").addValidators(Validators.required);
        this.addressShipping_FormGroup.get("zipcode").addValidators(Validators.minLength(5));
        this.addressShipping_FormGroup.get("zipcode").addValidators(Validators.maxLength(5));
        this.addressShipping_FormGroup.get("zipcode").addValidators(Validators.pattern("[0-9]+"));
      }
    }
    if (this.is_my_profile) {
      this.addressShipping_FormGroup.get("country").updateValueAndValidity();
      this.addressShipping_FormGroup.get("city").updateValueAndValidity();
      this.addressShipping_FormGroup.get("zipcode").updateValueAndValidity();
      this.addressShipping_FormGroup.get("province").updateValueAndValidity();
    }
  }
}
